export default __webpack_public_path__ + "static/jay_bw-a8d83c46175d999a7571c2238d5ea82e.jpg";